import { useEffect, useCallback } from 'react';
import { Capacitor } from '@capacitor/core';
import { differenceInDays } from 'date-fns';
import axios from 'App/axios';
import { makeDevicesMsPayload } from 'App/capacitor/device';
import useStorage from 'commons/hooks/useStorage';

export const VERIFY_TOKEN_KEY = 'verify-notification-token';
const REVALIDATE_TOKEN_AFTER_DAYS = 1;
const IS_NATIVE_PLATFORM = Capacitor.isNativePlatform();

export const validateDevice = async (): Promise<boolean> => {
  try {
    const payload = await makeDevicesMsPayload();
    await axios.put('/v1/devices/validate', payload);
    return true;
  } catch (error) {
    return false;
  }
};

function useVerifyNotificationToken(): { isDeviceValidated: boolean } {
  const [validatedDate, setValidatedDate, loaded] = useStorage<
    string | undefined
  >(VERIFY_TOKEN_KEY, undefined);

  const isDeviceValidated =
    loaded &&
    !!validatedDate &&
    differenceInDays(new Date(), new Date(validatedDate)) <
      REVALIDATE_TOKEN_AFTER_DAYS;

  const handleValidateDevice = useCallback(async () => {
    const isDeviceValidated = await validateDevice();
    if (isDeviceValidated) {
      setValidatedDate(new Date().toISOString());
    }
  }, [setValidatedDate]);

  useEffect(() => {
    if (!IS_NATIVE_PLATFORM || !loaded) return;

    if (!isDeviceValidated) {
      handleValidateDevice();
    }
  }, [isDeviceValidated, loaded, handleValidateDevice]);

  return { isDeviceValidated };
}

export default useVerifyNotificationToken;
